module.exports = __webpack_public_path__ + "static/img/logo-en.79e26ea7.png";